export default __webpack_public_path__ + "static/media/search-engine.9f53bea4.png";